import axios from 'axios'
import { Base_API } from '../_actions/matcher'
import {DecryptedOBJ, DecryptedText} from '../utils/Encryption'
import { navigateCallbackURL } from './sso.authen'
import { ALERT } from '../components/CustomAlert'


export const NhealthAction = {
    GetHospital,
    GetPackages,
    GetCampaign,
    CheckCampaign,
    GetHistoryAppoint,
    GetHistory,
    GetHistoryDetails,
    UpdateHistory,
    GetPackageByID,
    GetInfoClubCard,
    GetInfoCardCondition,
    GetInfoDetail,
    GetInfoContact,
    RegisMember,
    GetCard,
    GetMember,
    GetMemberNonlab,
    GetInfoCardDetail,
    AddCart,
    CalCart,
    DeleteCart,
    UpdateCart,
    CreateOrder,
    GetHistoryByTranNo,
    GetHospitalList,
    UpdateAppointment,
    GetTransHistory,
    GetTransHisByTransID,
    GetLogPoint,
    GetProductOnline,
    GetCampaignProductsOnline,
    GetProductOnlineByID,
    GetCoupons,
    sendOTP,
    verifyOTP,
    GetRewardsList,
    GetRewardDetailByID,
    RedeemReward,
    GetMyRewards,
    GetRedeemDetail,
    GetHisAppointAllTransByLineUser,
    LineRevoke,
    LineLogin,
    SignInPhone,
    JWT_Authen,
    SendOTP_SMS_SSO,
    SendOTP_Email_SSO,
    GetIPAdress,
    uploadImage,
    verifyOTP_SSO,
    PatientRegis,
    AuthorizeChannel,
    GetPatientProfile,
    PatientVerifySignIn,
    getDropdownOccupation,
    getProvince,
    getDistrict,
    getSubdistrict,
    getPostalcode,
    getDropdownIncomePerMonth,
    updatePatientProfile,
    updatePatient_identity_image,
    updatePatientAddress,
    updatePatientOccupation,
    updatePatientMedicalInfo,
    updatePatientMoreUploadfile,
    OCRfrontIdCard,
    FaceRecognition,
    OCRskip,
    hashValidation,
    econsentGetContact,
    econsentSetContact,
    econsentGetAllConsent,
    econsentSetConsent
}

function econsentGetContact(formData, JWT) {
    return axios.post(`${Base_API.api_sso}eConsent/get_contact`, formData, {
        headers: {
            eConsent_appid: Base_API.econsent_appid,
            Authorization: `Bearer ${JWT.token}`,
            userRef: JWT.userRef,
            authorizeRef: JWT.authorizeRef,
            channalRef: JWT.channalRef,
            clientId: process.env.REACT_APP_LAB_CLIENT_ID,
            clientSecret: process.env.REACT_APP_LAB_CLIENT_SECRET
        }
    })
    .then(res => {
        return res.data;
    })
    .catch(err => {
        console.error('Error API: E-Consent Get Contact');
        console.error(err);
        return;
    }) 
}
function econsentSetContact(formData, JWT) {
    return axios.post(`${Base_API.api_sso}eConsent/set_contact`, formData, {
        headers: {
            eConsent_appid: Base_API.econsent_appid,
            Authorization: `Bearer ${JWT.token}`,
            userRef: JWT.userRef,
            authorizeRef: JWT.authorizeRef,
            channalRef: JWT.channalRef,
            clientId: process.env.REACT_APP_LAB_CLIENT_ID,
            clientSecret: process.env.REACT_APP_LAB_CLIENT_SECRET
        }
    })
    .then(res => {
        return res.data;
    })
    .catch(err => {
        console.error('Error API: E-Consent Set Contact');
        console.error(err);
        return;
    }) 
}
function econsentGetAllConsent(formData, JWT) {
    return axios.post(`${Base_API.api_sso}eConsent/get_all_consent`, formData, {
        headers: {
            eConsent_appid: Base_API.econsent_appid,
            Authorization: `Bearer ${JWT.token}`,
            userRef: JWT.userRef,
            authorizeRef: JWT.authorizeRef,
            channalRef: JWT.channalRef,
            clientId: process.env.REACT_APP_LAB_CLIENT_ID,
            clientSecret: process.env.REACT_APP_LAB_CLIENT_SECRET
        }
    })
    .then(res => {
        return res.data;
    })
    .catch(err => {
        console.error('Error API: E-Consent Get All Consent');
        console.error(err);
        return;
    }) 
}
function econsentSetConsent(formData, JWT) {
    return axios.post(`${Base_API.api_sso}eConsent/set_consent`, formData, {
        headers: {
            eConsent_appid: Base_API.econsent_appid,
            Authorization: `Bearer ${JWT.token}`,
            userRef: JWT.userRef,
            authorizeRef: JWT.authorizeRef,
            channalRef: JWT.channalRef,
            clientId: process.env.REACT_APP_LAB_CLIENT_ID,
            clientSecret: process.env.REACT_APP_LAB_CLIENT_SECRET
        }
    })
    .then(res => {
        return res.data;
    })
    .catch(err => {
        console.error('Error API: E-Consent Set Consent');
        console.error(err);
        return;
    }) 
}


function FaceRecognition (formData) {
    return axios.post(`${Base_API.ocr_nh}/api/v1/face_recognize/verify_face`, formData, {
        headers: {
            'Content-Type': 'multipart/form-data',
            'client_id': Base_API.client_id_nh,
            'client_secret': Base_API.client_secret_nh
        }
    })
    .then(res => {
        return res.data;
    })
    .catch(err => {
        console.error('Error API: Face Recognition')
        console.error(err)
        return;
    }) 
}
function OCRfrontIdCard (formData) {
    return axios.post(`${Base_API.ocr_nh}/api/v1/ocr/front_personal_id_card`, formData, {
        headers: {
            'client_id': Base_API.client_id_nh,
            'client_secret': Base_API.client_secret_nh
        }
    })
    .then(res => {
        return res.data;
    })
    .catch(err => {
        console.error('Error API: OCR Front ID CARD')
        console.error(err)
        return;
    }) 
}
function OCRskip () {
    return axios.post(`${Base_API.ocr_nh}/api/v1/ocr/skip`, {}, {
        headers: {
            'client_id': Base_API.client_id_nh,
            'client_secret': Base_API.client_secret_nh
        }
    })
    .then(res => {
        return res.data;
    })
    .catch(err => {
        console.error('Error API: OCR Skip')
        console.error(err)
        return;
    }) 
}
function hashValidation (formData) {
    return axios.post(`${Base_API.ocr_nh}/api/v1/face_recognize/hash_validation`, formData, {
        headers: {
            'client_id': Base_API.client_id_nh,
            'client_secret': Base_API.client_secret_nh
        }
    })
    .then(res => {
        return res.data;
    })
    .catch(err => {
        console.error('Error API: Hash Validation')
        console.error(err)
        return;
    }) 
}

// SSO API
function updatePatientMoreUploadfile (reqData, JWT) {
    return axios.post(`${Base_API.api_sso}v200/patients/updatePatientMoreUploadfile`, reqData, {
        headers: {
            Authorization: `Bearer ${JWT.token}`,
            userRef: JWT.userRef,
            authorizeRef: JWT.authorizeRef,
            channalRef: JWT.channalRef,
            clientId: process.env.REACT_APP_LAB_CLIENT_ID,
            clientSecret: process.env.REACT_APP_LAB_CLIENT_SECRET
        }
    })
    .then(res => {
        return res.data;
    })
    .catch(err => {
        console.error('Error API: updatePatientMoreUploadfile')
        console.error(err)
        return;
    }) 
}
function updatePatientMedicalInfo (reqData, JWT) {
    return axios.post(`${Base_API.api_sso}v200/patients/updatePatientMedicalInfo`, reqData, {
        headers: {
            Authorization: `Bearer ${JWT.token}`,
            userRef: JWT.userRef,
            authorizeRef: JWT.authorizeRef,
            channalRef: JWT.channalRef,
            clientId: process.env.REACT_APP_LAB_CLIENT_ID,
            clientSecret: process.env.REACT_APP_LAB_CLIENT_SECRET
        }
    })
    .then(res => {
        return res.data;
    })
    .catch(err => {
        console.error('Error API: updatePatientMedicalInfo')
        console.error(err)
        return;
    }) 
}
function updatePatientOccupation (reqData, JWT) {
    return axios.post(`${Base_API.api_sso}v200/patients/updatePatientOccupation`, reqData, {
        headers: {
            Authorization: `Bearer ${JWT.token}`,
            userRef: JWT.userRef,
            authorizeRef: JWT.authorizeRef,
            channalRef: JWT.channalRef,
            clientId: process.env.REACT_APP_LAB_CLIENT_ID,
            clientSecret: process.env.REACT_APP_LAB_CLIENT_SECRET
        }
    })
    .then(res => {
        return res.data;
    })
    .catch(err => {
        console.error('Error API: updatePatientOccupation')
        console.error(err)
        return;
    }) 
}
function updatePatientAddress (reqData, JWT) {
    return axios.post(`${Base_API.api_sso}v200/patients/updatePatientAddress`, reqData, {
        headers: {
            Authorization: `Bearer ${JWT.token}`,
            userRef: JWT.userRef,
            authorizeRef: JWT.authorizeRef,
            channalRef: JWT.channalRef,
            clientId: process.env.REACT_APP_LAB_CLIENT_ID,
            clientSecret: process.env.REACT_APP_LAB_CLIENT_SECRET
        }
    })
    .then(res => {
        return res.data;
    })
    .catch(err => {
        console.error('Error API: updatePatientAddress')
        console.error(err)
        return;
    }) 
}
function updatePatient_identity_image (reqData, JWT) {
    return axios.post(`${Base_API.api_sso}v200/patients/updatePatient_identity_image`, reqData, {
        headers: {
            Authorization: `Bearer ${JWT.token}`,
            userRef: JWT.userRef,
            authorizeRef: JWT.authorizeRef,
            channalRef: JWT.channalRef,
            clientId: process.env.REACT_APP_LAB_CLIENT_ID,
            clientSecret: process.env.REACT_APP_LAB_CLIENT_SECRET
        }
    })
    .then(res => {
        return res.data;
    })
    .catch(err => {
        console.error('Error API: updatePatient_identity_image')
        console.error(err)
        return;
    }) 
}
function updatePatientProfile (reqData, JWT) {
    return axios.post(`${Base_API.api_sso}v200/patients/updatePatientProfile`, reqData, {
        headers: {
            Authorization: `Bearer ${JWT.token}`,
            userRef: JWT.userRef,
            authorizeRef: JWT.authorizeRef,
            channalRef: JWT.channalRef,
            clientId: process.env.REACT_APP_LAB_CLIENT_ID,
            clientSecret: process.env.REACT_APP_LAB_CLIENT_SECRET
        }
    })
    .then(res => {
        return res.data;
    })
    .catch(err => {
        console.error('Error API: updatePatientProfile')
        console.error(err)
        return;
    }) 
}

function getDropdownOccupation (JWT, lang) {
    return axios.get(`${Base_API.api_sso}main/getOccupation/${lang}`, {
        headers: {
            Authorization: `Bearer ${JWT.token}`,
            userRef: JWT.userRef,
            authorizeRef: JWT.authorizeRef,
            channalRef: JWT.channalRef,
            clientId: process.env.REACT_APP_LAB_CLIENT_ID,
            clientSecret: process.env.REACT_APP_LAB_CLIENT_SECRET
        }
    })
    .then(res => {
        return res.data;
    })
    .catch(err => {
        console.error('Error API: Get Drop down occupation')
        console.error(err)
        return;
    }) 
}
function getDropdownIncomePerMonth (JWT, lang) {
    return axios.get(`${Base_API.api_sso}main/getIncome_per_month/${lang}`, {
        headers: {
            Authorization: `Bearer ${JWT.token}`,
            userRef: JWT.userRef,
            authorizeRef: JWT.authorizeRef,
            channalRef: JWT.channalRef,
            clientId: process.env.REACT_APP_LAB_CLIENT_ID,
            clientSecret: process.env.REACT_APP_LAB_CLIENT_SECRET
        }
    })
    .then(res => {
        return res.data;
    })
    .catch(err => {
        console.error('Error API: Get Drop down income per month')
        console.error(err)
        return;
    }) 
}

function getProvince (lang, JWT) {
    return axios.get(`${Base_API.api_sso}main/getProvince/${lang}`,{
        headers: {
            Authorization: `Bearer ${JWT.token}`,
            userRef: JWT.userRef,
            authorizeRef: JWT.authorizeRef,
            channalRef: JWT.channalRef,
            clientId: process.env.REACT_APP_LAB_CLIENT_ID,
            clientSecret: process.env.REACT_APP_LAB_CLIENT_SECRET
        }
    })
    .then(res => {
        return res.data;
    })
    .catch(err => {
        console.error('Error API: Province');
        console.error(err);
        return;
    })
}

function getDistrict (language, coderef, JWT) {
    return axios.get(`${Base_API.api_sso}main/getDistrict/${language}/${coderef}`,{
        headers: {
            Authorization: `Bearer ${JWT.token}`,
            userRef: JWT.userRef,
            authorizeRef: JWT.authorizeRef,
            channalRef: JWT.channalRef,
            clientId: process.env.REACT_APP_LAB_CLIENT_ID,
            clientSecret: process.env.REACT_APP_LAB_CLIENT_SECRET
        }
    })
    .then(res => {
        return res.data;
    })
    .catch(err => {
        console.error('Error API: Province');
        console.error(err);
        return;
    })
}

function getSubdistrict  (language, coderef, JWT) {
    return axios.get(`${Base_API.api_sso}main/getSubdistrict/${language}/${coderef}`,{
        headers: {
            Authorization: `Bearer ${JWT.token}`,
            userRef: JWT.userRef,
            authorizeRef: JWT.authorizeRef,
            channalRef: JWT.channalRef,
            clientId: process.env.REACT_APP_LAB_CLIENT_ID,
            clientSecret: process.env.REACT_APP_LAB_CLIENT_SECRET
        }
    })
    .then(res => {
        return res.data;
    })
    .catch(err => {
        console.error('Error API: Province');
        console.error(err);
        return;
    })
}

function getPostalcode  (language, coderef, JWT) {
    return axios.get(`${Base_API.api_sso}main/getPostalcode/${language}/${coderef}`,{
        headers: {
            Authorization: `Bearer ${JWT.token}`,
            userRef: JWT.userRef,
            authorizeRef: JWT.authorizeRef,
            channalRef: JWT.channalRef,
            clientId: process.env.REACT_APP_LAB_CLIENT_ID,
            clientSecret: process.env.REACT_APP_LAB_CLIENT_SECRET
        }
    })
    .then(res => {
        return res.data;
    })
    .catch(err => {
        console.error('Error API: Province');
        console.error(err);
        return;
    })
}

function PatientVerifySignIn (reqData, JWT) {
    return axios.post(`${Base_API.api_sso}v200/patients/verifySignin`, reqData, {
        headers: {
            Authorization: `Bearer ${JWT.token}`,
            userRef: JWT.userRef,
            authorizeRef: JWT.authorizeRef,
            channalRef: JWT.channalRef,
            clientId: process.env.REACT_APP_LAB_CLIENT_ID,
            clientSecret: process.env.REACT_APP_LAB_CLIENT_SECRET
        }
    })
    .then(res => {
        return res.data;
    })
    .catch(err => {
        console.error('Error API: Patient Verify SignIn')
        console.error(err)
        return;
    })
}
function GetPatientProfile (reqData, JWT) {
    return axios.post(`${Base_API.api_sso}v200/patients/getPatient`, reqData, {
        headers: {
            Authorization: `Bearer ${JWT.token}`,
            userRef: JWT.userRef,
            authorizeRef: JWT.authorizeRef,
            channalRef: JWT.channalRef,
            clientId: process.env.REACT_APP_LAB_CLIENT_ID,
            clientSecret: process.env.REACT_APP_LAB_CLIENT_SECRET
        }
    })
    .then(res => {
        return res.data;
    })
    .catch(err => {
        console.error('Error API: Get Patient Profile')
        console.error(err)
        if(err.response.data.statusCode === 410)
        {
            ALERT.customAlert("แจ้งเตือน", "Session หมดอายุ", "ล็อคอินอีกครั้ง", () => {
                localStorage.clear();
                location.href = `${Base_API.pathWeb}/n-health/mycard`
            });
        }
        return;
    })
}
function AuthorizeChannel (reqData, JWT) {
    return axios.post(`${Base_API.api_sso}v200/patients/AuthorizationChannel`, reqData, {
        headers: {
            Authorization: `Bearer ${JWT.token}`,
            userRef: JWT.userRef,
            authorizeRef: JWT.authorizeRef,
            channalRef: JWT.channalRef,
            clientId: process.env.REACT_APP_LAB_CLIENT_ID,
            clientSecret: process.env.REACT_APP_LAB_CLIENT_SECRET
        }
    })
    .then(res => {
        return res.data;
    })
    .catch(err => {
        console.error('Error API: Authorize channel')
        console.error(err)
        return;
    })
}
function PatientRegis (reqData, JWT) {
    return axios.post(`${Base_API.api_sso}v200/patients/RegistrationPatient`, reqData, {
        headers: {
            Authorization: `Bearer ${JWT.token}`,
            userRef: JWT.userRef,
            authorizeRef: JWT.authorizeRef,
            channalRef: JWT.channalRef,
            clientId: process.env.REACT_APP_LAB_CLIENT_ID,
            clientSecret: process.env.REACT_APP_LAB_CLIENT_SECRET
        }
    })
    .then(res => {
        return res.data;
    })
    .catch(err => {
        console.error('Error API: Patient Register')
        console.error(err)
        return;
    })
}
function verifyOTP_SSO (reqData, JWT) {
    return axios.post(`${Base_API.api_sso}v200/patients/verifyOTP`, reqData, {
        headers: {
            Authorization: `Bearer ${JWT.token}`,
            userRef: JWT.userRef,
            authorizeRef: JWT.authorizeRef,
            channalRef: JWT.channalRef,
            clientId: process.env.REACT_APP_LAB_CLIENT_ID,
            clientSecret: process.env.REACT_APP_LAB_CLIENT_SECRET
        }
    })
    .then(res => {
        return res.data;
    })
    .catch(err => {
        console.error('Error API: Verify OTP SSO')
        console.error(err)
        if(err.response.status === 410)
        {
            localStorage.removeItem('line_profile')
            setTimeout(() => {
                location.reload();
            }, 1000)
        }
        return;
    })
}
function uploadImage (reqData, JWT) {
    return axios.post(`${Base_API.api_sso}v200/patients/upload_image`, reqData, {
        headers: {
            Authorization: `Bearer ${JWT.token}`,
            userRef: JWT.userRef,
            authorizeRef: JWT.authorizeRef,
            channalRef: JWT.channalRef,
            clientId: process.env.REACT_APP_LAB_CLIENT_ID,
            clientSecret: process.env.REACT_APP_LAB_CLIENT_SECRET
        }
    })
    .then(res => {
        return res.data;
    })
    .catch(err => {
        console.error('Error API: Upload Image')
        console.error(err)
        return;
    })
}
function GetIPAdress(reqData) {
    return axios.get(`https://api.ipify.org?format=json`, reqData)
    .then(res => {
        return res.data.ip;
    })
    .catch(err => {
        console.error('Error API: Get IP Adress')
        console.error(err)
        return;
    })
}
function SendOTP_SMS_SSO(reqData, JWT) {
    return axios.post(`${Base_API.api_sso}v200/patients/getOTP_SMS`, reqData, {
        headers: {
            Authorization: `Bearer ${JWT.token}`,
            userRef: JWT.userRef,
            authorizeRef: JWT.authorizeRef,
            channalRef: JWT.channalRef,
            clientId: process.env.REACT_APP_LAB_CLIENT_ID,
            clientSecret: process.env.REACT_APP_LAB_CLIENT_SECRET
        }
    })
    .then(res => {
        if(res.data.IsSuccess)
        {
            return res.data;
        }
    })
    .catch(err => {
        console.error('Error API: Send OTP SMS')
        console.error(err)

        if(err.response.data.statusCode === 410)
        {
            localStorage.removeItem('line_profile')
            localStorage.removeItem(process.env.REACT_APP_ENC_NAME_SIGNIN_RESPONSE);
            localStorage.removeItem(process.env.REACT_APP_ENC_NAME_PATIENT_PROFILE_DATA);
            setTimeout(() => {
                navigateCallbackURL(); 
            }, 1000) 
        }
        return;
    })
}
function SendOTP_Email_SSO(reqData, headers) {
    return axios.post(`${Base_API.api_sso}v200/patients/getOTP_Email`, reqData, {
        headers: {
            clientId: process.env.REACT_APP_LAB_CLIENT_ID,
            clientSecret: process.env.REACT_APP_LAB_CLIENT_SECRET
        }
    })
    .then(res => {
        return res.data;
    })
    .catch(err => {
        console.error('Error API: Send OTP Email')
        console.error(err)
        return;
    })
}
function JWT_Authen(reqData) {
    return axios.post(`${Base_API.api_sso}JWTAuthen/Authorization`, reqData, {
        headers: {
            clientId: process.env.REACT_APP_LAB_CLIENT_ID,
            clientSecret: process.env.REACT_APP_LAB_CLIENT_SECRET
        }
    })
    .then(res => {
        //console.log(res)
        return res.data
    })
    .catch(err => {
        console.error(err)
        console.error('Error Api: JWT Authen')
        return;
    })
}

function SignInPhone(reqData, headers) {
    headers.headers["clientId"] = process.env.REACT_APP_LAB_CLIENT_ID;
    headers.headers["clientSecret"] = process.env.REACT_APP_LAB_CLIENT_SECRET;
    return axios.post(`${Base_API.api_sso}v200/patients/Signin_phone`, reqData, headers)
    .then(res => {
        //console.log(res)
        return res.data
    })
    .catch(err => {
        console.error(err)
        console.error('Error Api: Sign In Phone')
        return;
    })
}

// Lab API

function GetLineProfile() {
    let lineProfile = localStorage.getItem('line_profile');
    var accessToken;
    if(!!lineProfile && lineProfile !== null && lineProfile !== "" && lineProfile !== undefined)
    {
        accessToken = DecryptedOBJ(localStorage.getItem('line_profile')).access_token;
        return accessToken;
    }
    return accessToken;
}

function LineRevoke(formData) {
    let option = {
        method: 'GET',
        headers: { 'content-type': 'application/x-www-form-urlencoded' },
        data: qs.stringify(formData),
        url: `${Base_API.lineapi}/revoke`,
    };
    return axios.post(option)
    .then(res => {
        return res.data;
    })
}
function LineLogin(accessToken) {
    return axios.get(`${Base_API.lineapi}/verify?access_token=${accessToken}`)
    .then(res => {
        return res;
    })
}

function UpdateHistory(reqData) {
    return axios.post(`${Base_API.lab}/History/_updatehistory`, reqData, {headers: {access_token: GetLineProfile()}})
    .then(res => {
        //console.log(res)
        return res.data
    })
    .catch(err => {
        console.error(err)
        console.error('Error Api: Update History')
        return;
    })
}
// Transaction History
function GetHistory(reqData) {
    return axios.post(`${Base_API.lab}/History/_gethistory_lab`, reqData, {headers: {access_token: GetLineProfile()}})
    .then(res => {
        //console.log(res)
        return res.data
    })
    .catch(err => {
        console.error(err)
        console.error('Error Api: Get History')
        return;
    })
}
function GetHistoryDetails(reqData) {
    return axios.post(`${Base_API.lab}/History/_gethistory_lab_detail`, reqData, {headers: {access_token: GetLineProfile()}})
    .then(res => {
        //console.log(res)
        return res.data
    })
    .catch(err => {
        console.error(err)
        console.error('Error Api: Get History Details')
        return;
    })
}
function GetHistoryAppoint(reqData) {
    return axios.post(`${Base_API.lab}/History/_gethistory_lab_appoint`, reqData, {headers: {access_token: GetLineProfile()}})
    .then(res => {
        //console.log(res)
        return res.data
    })
    .catch(err => {
        console.error(err)
        console.error('Error Api: Get History')
        return;
    })
}

function GetCampaign(ref) {
    // return axios.get(`${Base_API.lab}/api/_getCampaign_lab_preview?_ref=${ref}`)
    return axios.get(`${Base_API.lab}/api/_getCampaign_lab?_ref=${ref}`, {headers: {access_token: GetLineProfile()}})
    .then(res => {
        //console.log(res)
        return res.data
    })
    .catch(err => {
        console.error(err)
        console.error('Error Api: Get Products')
        return;
    })
}
function CheckCampaign() {
    return axios.get(`${Base_API.lab}/Campaign/_checkCampaign_lab`, {headers: {access_token: GetLineProfile()}})
    .then(res => {
        //console.log(res)
        return res.data
    })
    .catch(err => {
        console.error(err)
        console.error('Error Api: Get Check Campaign')
        return;
    })
}

function GetHospital(id) {
    return axios.get(`${Base_API.lab}/webserviceapp/api/Appointment/getHospital?government=0`, {headers: {access_token: GetLineProfile()}})
    .then(res => {
        return res.data;
    })
    .catch(err => {
        console.error('Error Api')
        return console.error(err)
    })
}

function GetPackageByID(id) {
    return axios.get(`${Base_API.lab}/api/_getPackage?id=${id}`, {headers: {access_token: GetLineProfile()}})
    .then(res => {
        //console.log(res)
        return res.data
    })
    .catch(err => {
        console.error(err)
        console.error('Error Api: Get Package By ID')
        return;
    })
}
function GetPackages(ref) {
    // return axios.get(`${Base_API.lab}/api/_getlab_preview?_ref=${ref}`)
    return axios.get(`${Base_API.lab}/api/_getlab?_ref=${ref}`, {headers: {access_token: GetLineProfile()}})
    // return axios.get(`${Base_API.lab}/Campaign/_getlab`)
    .then(res => {
        // console.log(res)
        return res.data
    })
    .catch(err => {
        console.error(err)
        console.error('Error Api: Get Packages')
        return;
    })
}

// NHealth - Card
function GetInfoClubCard() {
    return axios.get(`${Base_API.lab}/api/_get_info_ClubCard_lab`, {headers: {access_token: GetLineProfile()}})
    .then(res => {
        return res.data;
    })
    .catch(err => {
        console.error(err)
        console.error('Error Api: Get Info Club Card!')
        return;
    })
}
function GetInfoCardCondition() {
    return axios.get(`${Base_API.lab}/api/_get_info_Cardcondition_lab`, {headers: {access_token: GetLineProfile()}})
    .then(res => {
        return res.data;
    })
    .catch(err => {
        console.error(err)
        console.error('Error Api: Get Info Card Condition!')
        return;
    })
}
function GetInfoDetail() {
    return axios.get(`${Base_API.lab}/api/_get_info_detail_lab`, {headers: {access_token: GetLineProfile()}})
    .then(res => {
        return res.data;
    })
    .catch(err => {
        console.error(err)
        console.error('Error Api: Get Info Detail!')
        return;
    })
}
function GetInfoContact() {
    return axios.get(`${Base_API.lab}/api/_get_info_contact_lab`, {headers: {access_token: GetLineProfile()}})
    .then(res => {
        return res.data;
    })
    .catch(err => {
        console.error(err)
        console.error('Error Api: Get Info Contact!')
        return;
    })
}
function RegisMember(reqData) {
    return axios.post(`${Base_API.lab}/api/_regisMember_lab`, reqData, {headers: {access_token: GetLineProfile()}})
    .then(res => {
        return res.data;
    })
    .catch(err => {
        console.error(err)
        console.error('Error Api: Register Member!')
        return;
    })
}
function GetCard(cardID) {
    return axios.get(`${Base_API.lab}/api/_getCard?cardid=${cardID}`, {headers: {access_token: GetLineProfile()}})
    .then(res => {
        return res.data;
    })
    .catch(err => {
        console.error(err)
        console.error('Error Api: Get Card!')
        return;
    })       
}
function GetMember(lineUser) {
    return axios.get(`${Base_API.lab}/api/_getMember_lab?line_user=${lineUser}`, {headers: {access_token: GetLineProfile()}})
    .then(res => {
        if(res.data.isSuccess)
        {
            return res.data;
        }else
        {
            if(res.data.errMessage === "authen expired !.")
            {
                localStorage.removeItem('line_profile')
                setTimeout(() => {
                    location.reload();
                }, 1000)
            }
            return res.data;
        }
    })
    .catch(err => {
        console.error(err)
        console.error('Error Api: Get Member!')
        return;
    })       
}
function GetMemberNonlab(lineUser) {
    return axios.get(`${Base_API.lab}/api/_getMember_nonlab?line_user=${lineUser}`, {headers: {access_token: GetLineProfile()}})
    .then(res => {
        if(res.data.isSuccess)
        {
            return res.data;
        }else
        {
            if(res.data.errMessage === "authen expired !.")
            {
                localStorage.removeItem('line_profile')
                setTimeout(() => {
                    location.reload();
                }, 1000)
            }
            return res.data;
        }
    })
    .catch(err => {
        console.error(err)
        console.error('Error Api: Get Member!')
        return;
    })       
}
function GetInfoCardDetail(tierType) {
    return axios.get(`${Base_API.lab}/api/_get_info_Carddetail_lab?tiertype=${tierType}`, {headers: {access_token: GetLineProfile()}})
    .then(res => {
        return res.data;
    })
    .catch(err => {
        console.error(err)
        console.error('Error Api: Get Info Card Detail!')
        return;
    })        
}
// NHealth - Cart
function AddCart(reqData) {
    return axios.post(`${Base_API.lab}/api/_addCart`, reqData, {headers: {access_token: GetLineProfile()}})
    .then(res => {
        return res.data;
    })
    .catch(err => {
        console.error(err)
        console.error('Error Api: Add Cart!')
        return;
    })        
}
function UpdateCart(reqData) {
    return axios.post(`${Base_API.lab}/api/_updateCart`, reqData, {headers: {access_token: GetLineProfile()}})
    .then(res => {
        return res.data;
    })
    .catch(err => {
        console.error(err)
        console.error('Error Api: Update Cart!')
        return;
    })        
}
function DeleteCart(cardid) {
    return axios.get(`${Base_API.lab}/api/_removeCart?cartid=${cardid}`, {headers: {access_token: GetLineProfile()}})
    .then(res => {
        return res.data;
    })
    .catch(err => {
        console.error(err)
        console.error('Error Api: Delete Cart!')
        return;
    })        
}
function CalCart(campaign, coupon, membercode) {
    return axios.get(`${Base_API.lab}/api/_calCart?campaign=${campaign}&coupon=${coupon}&membercode=${membercode}&_postcode=`, {headers: {access_token: GetLineProfile()}})
    .then(res => {
        return res.data;
    })
    .catch(err => {
        console.error(err)
        console.error('Error Api: Calculate Cart!')
        return;
    })        
}
function CreateOrder(reqData) {
    return axios.post(`${Base_API.lab}/api/_createorder`, reqData, {headers: {access_token: GetLineProfile()}})
    .then(res => {
        return res.data;
    })
    .catch(err => {
        console.error(err)
        console.error('Error Api: Create Order!')
        return;
    })        
}
// Appointment
function GetHistoryByTranNo(tran_no) {
    return axios.get(`${Base_API.lab}/api/_gethistory_tranno?_tranno=${tran_no}`, {headers: {access_token: GetLineProfile()}})
    .then(res => {
        return res.data;
    })
    .catch(err => {
        console.error(err)
        console.error('Error Api: Get History By Tran No!')
        return;
    })        
}
function GetHospitalList(campaignID) {
    return axios.get(`${Base_API.lab}/api/_getHospital?campaign=${campaignID}`, {headers: {access_token: GetLineProfile()}})
    .then(res => {
        return res.data;
    })
    .catch(err => {
        console.error(err)
        console.error('Error Api: Get Hospital List!')
        return;
    })        
}
function UpdateAppointment(reqData) {
    return axios.post(`${Base_API.lab}/api/_updateappoint`, reqData, {headers: {access_token: GetLineProfile()}})
    .then(res => {
        return res.data;
    })
    .catch(err => {
        console.error(err)
        console.error('Error Api: Update Appointment!')
        return;
    })        
}
function GetTransHistory(lineUser) {
    return axios.get(`${Base_API.lab}/api/_gethistory_lab?line_user=${lineUser}`, {headers: {access_token: GetLineProfile()}})
    .then(res => {
        return res.data;
    })
    .catch(err => {
        console.error(err)
        console.error('Error Api: Get Transaction History!')
        return;
    })        
}
function GetTransHisByTransID(transID) {
    return axios.get(`${Base_API.lab}/api/_gethistory_detail?tranid=${transID}`, {headers: {access_token: GetLineProfile()}})
    .then(res => {
        return res.data;
    })
    .catch(err => {
        console.error(err)
        console.error('Error Api: Get Transaction History By Trans ID!')
        return;
    })        
}
function GetLogPoint(cardID) {
    return axios.get(`${Base_API.lab}/api/_get_logpoint_lab?cardid=${cardID}`, {headers: {access_token: GetLineProfile()}})
    .then(res => {
        return res.data;
    })
    .catch(err => {
        console.error(err)
        console.error('Error Api: Get Log Point!')
        return;
    })        
}
function GetProductOnline() {
    return axios.get(`${Base_API.lab}/api/_getlab_all`, {headers: {access_token: GetLineProfile()}})
    .then(res => {
        return res.data;
    })
    .catch(err => {
        console.error(err)
        console.error('Error Api: Get Nhealth Services !')
        return;
    })        
}
function GetCampaignProductsOnline() {
    return axios.get(`${Base_API.lab}/api/_getCampaign_lab?_ref=lab`, {headers: {access_token: GetLineProfile()}})
    // return axios.get(`${Base_API.nonlab}/Campaign/_getCampaign_nonlab`)
    .then(res => {
        // console.log(res)
        return res.data
    })
    .catch(err => {
        console.error(err)
        console.error('Error Api: Get Campaign Product Online')
        return;
    })
}
function GetProductOnlineByID(id) {
    return axios.get(`${Base_API.lab}/api/_getPackageall?id=${id}`, {headers: {access_token: GetLineProfile()}})
    .then(res => {
        return res.data;
    })
    .catch(err => {
        console.error(err)
        console.error('Error Api: Get Product Online By ID !')
        return;
    })        
}
function GetCoupons(campaignID, couponCode, memberCode) {
    return axios.get(`${Base_API.lab}/api/_getCoupon?campaign=${campaignID}&couponCode=${couponCode}&membercode=${memberCode}`, {headers: {access_token: GetLineProfile()}})
    .then(res => {
        return res.data;
    })
    .catch(err => {
        console.error(err)
        console.error('Error Api: Get Coupons !')
        return;
    })        
}
function sendOTP(formData) {
    return axios.post(`${Base_API.lab}/api/_getOTP`, formData, {headers: {access_token: GetLineProfile()}})
    .then(res => {
        return res.data;
    })
    .catch(err => {
        console.error(err)
        console.error('Error Api: Send OTP !')
        return;
    })        
}
function verifyOTP(formData) {
    return axios.post(`${Base_API.lab}/api/_verifyOTP`, formData, {headers: {access_token: GetLineProfile()}})
    .then(res => {
        return res.data;
    })
    .catch(err => {
        console.error(err)
        console.error('Error Api: Verify OTP !')
        return;
    })        
}
function GetRewardsList() {
    return axios.get(`${Base_API.lab}/api/_get_reward_lab`, {headers: {access_token: GetLineProfile()}})
    .then(res => {
        return res.data;
    })
    .catch(err => {
        console.error(err)
        console.error('Error Api: Get Rewards List !')
        return;
    })        
}
function GetRewardDetailByID(id) {
    return axios.get(`${Base_API.lab}/api/_get_reward_detail_lab?id=${id}`, {headers: {access_token: GetLineProfile()}})

    .then(res => {
        return res.data;
    })
    .catch(err => {
        console.error(err)
        console.error('Error Api: Get Rewards Detail By ID !')
        return;
    })        
}
function RedeemReward(formData) {
    return axios.post(`${Base_API.lab}/api/_redeemReward_lab`, formData, {headers: {access_token: GetLineProfile()}})
    .then(res => {
        return res.data;
    })
    .catch(err => {
        console.error(err)
        console.error('Error Api: Redeem Reward !')
        return;
    })        
}
function GetMyRewards(memberCode) {
    return axios.get(`${Base_API.lab}/api/_get_redeem_lab?membercode=${memberCode}`, {headers: {access_token: GetLineProfile()}})
    .then(res => {
        return res.data;
    })
    .catch(err => {
        console.error(err)
        console.error('Error Api: Get My Rewards !')
        return;
    })        
}
function GetRedeemDetail(id, memberCode) {
    return axios.get(`${Base_API.lab}/api/_get_redeem_detail?id=${id}&membercode=${memberCode}`, {headers: {access_token: GetLineProfile()}})
    .then(res => {
        return res.data;
    })
    .catch(err => {
        console.error(err)
        console.error('Error Api: Get Redeem Detail By ID !')
        return;
    })        
}
function GetHisAppointAllTransByLineUser(lineUser) {
    return axios.get(`${Base_API.lab}/api/_gethistory_appoint_alltran?line_user=${lineUser}`, {headers: {access_token: GetLineProfile()}})
    .then(res => {
        return res.data;
    })
    .catch(err => {
        console.error(err)
        console.error('Error Api: Get History Appoint All Transaction By Line User !')
        return;
    })        
}